import { createContext, useContext } from 'react';
import type { UIFlagFilter } from '@gonfalon/flag-filters/types';

import type { ViewSelectedResource } from './components/AddResourcesToViewModal';
import type { LinkableResourceType, View } from './types';

type ViewCreationContextType = {
  openCreateModal: (
    initialName?: string,
    flagFilters?: UIFlagFilter,
    resourceType?: LinkableResourceType,
    initialSelectedResources?: Array<ViewSelectedResource<LinkableResourceType>>,
  ) => void;
  setOnViewCreated: (callback: ((view: View) => void) | undefined) => void;
};

const defaultContextValue: ViewCreationContextType = {
  openCreateModal: () => {
    // No-op when used outside of ViewCreationProvider
  },
  setOnViewCreated: () => {
    // No-op when used outside of ViewCreationProvider
  },
};

const ViewCreationContext = createContext<ViewCreationContextType>(defaultContextValue);

export const useViewCreation = () => useContext(ViewCreationContext);

export { ViewCreationContext };
